import * as React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import Loader from '../../core/components/Loading/Loader';
import ModuleEventSubscriber from '../../core/helpers/ModuleEventSubscriber';
import { EventsList } from '../../core/lists/EventsList';
import { ModuleNamesList } from '../../core/lists/ModuleNamesList';
import TranslationService from '../../core/services/TranslationService';
import { IModuleProps } from '../../core/types/IModuleProps';
import CaseStatisticsCasesOverdueApiClient from './CaseStatisticsInvoiceAgingApiClient';
import { IPortfolioChartData } from './types/IPortfolioChartData';
import './_CaseStatisticsInvoiceAging.scss';
import { IModuleEventSubscription } from '../../core/types/IModuleEventSubscription';
import withAbortRequest, { AbortRequestPropsType } from '../../core/hoc/AbortRequest';

interface IProps extends IModuleProps, AbortRequestPropsType {
  locale: string;
}

interface IState {
  data: IPortfolioChartData[];
  loading: boolean;
  numOfInvoices: number;
}

class CaseStatisticsInvoiceAging extends React.Component<IProps, IState> {
  public state: IState = {
    loading: false,
    data: [],
    numOfInvoices: 0,
  };
  private moduleEvents: IModuleEventSubscription[];

  public componentDidMount = async () => {
    this.registerModuleEvents();
    await this.loadData();
  };

  public componentWillUnmount() {
    ModuleEventSubscriber.unsubscribeEvents(this.moduleEvents);
  }

  public loadData = async () => {
    this.setState({
      loading: true,
      data: [],
      numOfInvoices: 0,
    });
    const { data, numOfInvoices } = await CaseStatisticsCasesOverdueApiClient.GetData(
      this.props.cancelTokenSource.token
    );

    this.setState(() => {
      const agingData = data.filter((item) => {
        return item.value > 0;
      });

      return {
        loading: false,
        data: agingData,
        numOfInvoices: numOfInvoices,
      };
    });
  };

  public render() {
    return (
      <div className="module-box">
        <div className="module-box__content">
          <header
            className="module-box__header"
            dangerouslySetInnerHTML={{
              __html: TranslationService.translateModule('ChartHeader', ModuleNamesList.CaseStatisticsInvoiceAging),
            }}
          />
          <div className="module-box-content chart-invoices-aging">
            {this.state.loading ? (
              <Loader />
            ) : (
              <div className="chart">
                <div className="chart__main">
                  <div className="invoices-counter">
                    <p className="count">{this.state.numOfInvoices}</p>
                    <p className="desc">
                      {TranslationService.translateModule('TotalInvoices', ModuleNamesList.CaseStatisticsInvoiceAging)}
                    </p>
                  </div>
                  <PieChart data={this.state.data} lineWidth={28} labelPosition={110} />
                </div>

                <ul className="chart__legend">
                  {this.state.data.map((elem: any, index: number) => {
                    return (
                      <li key={index} data-value={elem.subHeader}>
                        {elem.textValue}
                      </li>
                    );
                  })}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private registerModuleEvents() {
    this.moduleEvents = [{ name: EventsList.CHANGED_CURRENT_CREDITOR, callback: this.loadData }];
    ModuleEventSubscriber.registerEvents(this.moduleEvents);
  }
}
export default withAbortRequest(CaseStatisticsInvoiceAging);
